import { Dialog, styled } from '@mui/material';

export const RoundedDialog = styled(Dialog)({
	'& .MuiPaper-root': {
		borderRadius: '25px',
	},
});
